/* ==========================================================================
   SPIDER — comportamento da página (só no template product.spider)
   ========================================================================== */
(function () {
  if (window.__spInit) return;
  window.__spInit = 1;

  var root = document.documentElement;
  if (!root.classList.contains('spider-page')) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Entrada em cena ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.sp-reveal');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. Fios de teia ao escolher o tamanho ---------- */
  function webBurst(host, count) {
    if (reduced || !host) return;
    var n = count || 7;
    for (var i = 0; i < n; i++) {
      var s = document.createElement('i');
      var a = (Math.PI * 2 * i) / n + Math.random() * 0.4;
      var d = 24 + Math.random() * 30;
      s.className = 'sp-thread-bit';
      s.style.cssText =
        'position:absolute;top:50%;left:50%;width:2px;height:' + (10 + Math.random() * 10).toFixed(0) +
        'px;background:linear-gradient(180deg,#fff,rgba(255,255,255,0));pointer-events:none;z-index:3;' +
        'transform-origin:top center;transform:translate(-50%,-50%) rotate(' + (a * 57.3).toFixed(0) + 'deg);' +
        'opacity:1;transition:transform .6s cubic-bezier(.22,1,.36,1),opacity .6s ease';
      host.appendChild(s);
      (function (el, ang, dist) {
        requestAnimationFrame(function () {
          el.style.transform =
            'translate(calc(-50% + ' + (Math.cos(ang) * dist).toFixed(1) + 'px), calc(-50% + ' +
            (Math.sin(ang) * dist).toFixed(1) + 'px)) rotate(' + (ang * 57.3).toFixed(0) + 'deg) scale(.4)';
          el.style.opacity = '0';
        });
        setTimeout(function () { el.remove(); }, 700);
      })(s, a, d);
    }
  }

  function initSizes() {
    var box = document.querySelector('.pdp__sizes');
    if (!box) return;
    box.addEventListener('change', function (e) {
      var input = e.target.closest('input[type="radio"]');
      if (!input) return;
      var label = input.closest('.pdp__size');
      if (label) webBurst(label, 7);
    });
  }

  /* ---------- 3. Trocador de modelo: entra dentro da caixa de compra ---------- */
  function initSwitch() {
    var sw = document.querySelector('[data-sp-switch]');
    if (!sw) return;
    var form = document.querySelector('.pdp__form');
    if (!form) return;
    var sizes = form.querySelector('.pdp__row');
    var guide = form.querySelector('.pdp__combo-guide');
    sw.hidden = false;
    if (sizes) form.insertBefore(sw, sizes);
    else if (guide) form.insertBefore(sw, guide);
    else form.insertBefore(sw, form.firstChild);
  }

  /* ---------- 4. Upsell: adicionar rápido + medidor 3 por 2 ---------- */
  function initUpsell() {
    var sec = document.querySelector('[data-sp-up]');
    if (!sec) return;

    var meter = sec.querySelector('[data-sp-meter]');
    var deny = (sec.getAttribute('data-deny') || '').split(',').filter(Boolean);
    var tiers = (sec.getAttribute('data-tiers') || '3,5,7,9').split(',').map(Number);

    function eligible(cart) {
      var n = 0;
      (cart.items || []).forEach(function (it) {
        var hay = ((it.product_title || '') + ' ' + (it.handle || '')).toLowerCase();
        for (var i = 0; i < deny.length; i++) {
          if (deny[i] && hay.indexOf(deny[i]) !== -1) return;
        }
        n += it.quantity || 0;
      });
      return n;
    }

    function paint(count) {
      if (!meter) return;
      var target = tiers[tiers.length - 1];
      var maxed = true;
      for (var i = 0; i < tiers.length; i++) {
        if (count < tiers[i]) { target = tiers[i]; maxed = false; break; }
      }
      var pay = Math.ceil(target / 2);
      var free = target - pay;
      var filled = Math.min(count, target);
      var rem = Math.max(target - count, 0);

      var msg = meter.querySelector('[data-sp-meter-msg]');
      if (msg) {
        var tpl = maxed ? meter.getAttribute('data-msg-max') : meter.getAttribute('data-msg-add');
        msg.innerHTML = (tpl || '')
          .replace('[rem]', '<b>' + rem + '</b>')
          .replace('[free]', '<b>' + free + '</b>')
          .replace('[target]', '<b>' + target + '</b>');
      }

      var pips = meter.querySelector('[data-sp-meter-pips]');
      if (pips) {
        var svg = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8.5 3 5 5.5 3.2 8.8l2.3 1.5.5-.8V21h12V9.5l.5.8 2.3-1.5L19 5.5 15.5 3l-1.4 1.6a3 3 0 0 1-4.2 0L8.5 3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
        var html = '';
        for (var j = 1; j <= target; j++) {
          html += '<span class="sp-meter__pip' + (j <= filled ? ' is-filled' : '') + '">' + svg + '</span>';
        }
        pips.innerHTML = html;
      }

      var fill = meter.querySelector('[data-sp-meter-fill]');
      if (fill) fill.style.width = Math.round((filled / target) * 100) + '%';
    }

    function refresh() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { paint(eligible(c)); })
        .catch(function () {});
    }

    if (meter) {
      var start = parseInt(meter.getAttribute('data-count'), 10) || 0;
      requestAnimationFrame(function () { paint(start); });
    }

    sec.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-sp-add]');
      if (toggle) {
        var card = toggle.closest('.sp-card');
        var wasOpen = card.classList.contains('is-open');
        sec.querySelectorAll('.sp-card.is-open').forEach(function (c) { c.classList.remove('is-open'); });
        if (!wasOpen) card.classList.add('is-open');
        return;
      }

      var chip = e.target.closest('[data-sp-var]');
      if (!chip || chip.disabled) return;
      var card2 = chip.closest('.sp-card');
      var id = chip.getAttribute('data-sp-var');
      chip.disabled = true;
      chip.style.position = 'relative';
      webBurst(chip, 5);

      var done = function () {
        chip.disabled = false;
        card2.classList.remove('is-open');
        card2.classList.add('is-added');
        var btn = card2.querySelector('[data-sp-add]');
        if (btn) {
          var old = btn.getAttribute('data-label') || btn.textContent;
          btn.setAttribute('data-label', old);
          btn.textContent = btn.getAttribute('data-added-label') || 'In the bag';
          setTimeout(function () {
            btn.textContent = old;
            card2.classList.remove('is-added');
          }, 2600);
        }
        refresh();
      };

      if (window.MatchdayCart && window.MatchdayCart.addAndOpen) {
        window.MatchdayCart.addAndOpen([{ id: id, quantity: 1 }]).then(done);
      } else {
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(done).catch(done);
      }
    });

    document.addEventListener('submit', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('pdp__form')) {
        setTimeout(refresh, 1200);
      }
    });
  }

  /* ---------- 5. Cromo: mensagens da barra e logo desta página ---------- */
  function initChrome() {
    var skin = document.querySelector('[data-sp-skin]');
    if (!skin) return;

    var logo = (skin.getAttribute('data-logo') || '').trim();
    if (logo) {
      var box = document.querySelector('.mdhdr__logo');
      if (box) {
        var img = box.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          var txt = box.querySelector('.mdhdr__logo-text');
          if (txt) txt.remove();
          box.insertBefore(img, box.firstChild);
        }
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = logo;
        var h = parseInt(skin.getAttribute('data-logo-h'), 10);
        if (h) { img.style.height = h + 'px'; img.style.width = 'auto'; }
      }
    }

    var raw = (skin.getAttribute('data-ann') || '').trim();
    if (raw) {
      var msgs = raw.split('||').map(function (m) { return m.trim(); }).filter(Boolean);
      if (msgs.length) {
        document.querySelectorAll('announcement-bar .announcement__slide').forEach(function (s, i) {
          var t = s.querySelector('.announcement__text span') || s.querySelector('.announcement__text');
          if (t) t.textContent = msgs[i % msgs.length];
        });
      }
    }
  }

  /* ---------- 6. Troca de uniforme: o simbionte cobre a tela e leva pra outra camisa ---------- */
  var SUIT_COLOR = { red: '#7d0d16', black: '#0c0c11', combo: '#12103a' };
  var SUIT_WORD = { red: 'Red suit', black: 'Symbiote', combo: 'Both suits' };

  function makeSwap(color, word) {
    var el = document.createElement('div');
    el.className = 'sp-swap';
    el.style.setProperty('--swap-bg', color);
    if (word) {
      var w = document.createElement('span');
      w.className = 'sp-swap__word';
      w.textContent = word;
      el.appendChild(w);
    }
    document.body.appendChild(el);
    return el;
  }

  function initSuitSwap() {
    var row = document.querySelector('[data-sp-switch]');
    if (row) {
      row.addEventListener('click', function (e) {
        var item = e.target.closest('.sp-switch__item');
        if (!item || item.classList.contains('is-active')) return;
        if (reduced || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        var suit = item.getAttribute('data-suit') || 'red';
        var href = item.getAttribute('href');
        try { sessionStorage.setItem('sp_swap', suit); } catch (err) {}
        var el = makeSwap(SUIT_COLOR[suit] || '#0c0c11', SUIT_WORD[suit] || '');
        el.classList.add('is-in');
        setTimeout(function () { window.location.href = href; }, 560);
      });
    }

    // chegada: a mancha sai de cena revelando a camisa nova
    var incoming = null;
    try { incoming = sessionStorage.getItem('sp_swap'); } catch (err) {}
    if (incoming && !reduced) {
      try { sessionStorage.removeItem('sp_swap'); } catch (err) {}
      var suit2 = root.getAttribute('data-spider') || incoming;
      var el2 = makeSwap(SUIT_COLOR[suit2] || '#0c0c11', '');
      el2.classList.add('is-out');
      setTimeout(function () { el2.remove(); }, 900);
    }
  }

  /* ---------- 7. Web-shooter: a camisa vai pro carrinho pendurada num fio ---------- */
  function flyToCart(fromEl) {
    if (reduced || !fromEl) return;
    var cart = document.querySelector('.mdhdr__cart');
    var shot = document.querySelector('.pdp__slide img, .pdp__stage img');
    if (!cart) return;

    var a = fromEl.getBoundingClientRect();
    var b = cart.getBoundingClientRect();
    var x1 = a.left + a.width / 2;
    var y1 = a.top + a.height / 2;
    var x2 = b.left + b.width / 2;
    var y2 = b.top + b.height / 2;
    var dx = x2 - x1;
    var dy = y2 - y1;
    var len = Math.sqrt(dx * dx + dy * dy);
    var ang = (Math.atan2(dy, dx) * 180) / Math.PI;

    var line = document.createElement('i');
    line.className = 'sp-thwip';
    line.style.left = x1 + 'px';
    line.style.top = y1 + 'px';
    line.style.width = len + 'px';
    line.style.transform = 'rotate(' + ang.toFixed(2) + 'deg)';
    document.body.appendChild(line);
    setTimeout(function () { line.remove(); }, 700);

    var sfx = document.createElement('span');
    sfx.className = 'sp-sfx';
    sfx.textContent = 'THWIP!';
    sfx.style.left = Math.min(x1 + 10, window.innerWidth - 160) + 'px';
    sfx.style.top = Math.max(y1 - 54, 10) + 'px';
    document.body.appendChild(sfx);
    setTimeout(function () { sfx.remove(); }, 800);

    if (shot) {
      var fly = document.createElement('div');
      fly.className = 'sp-fly';
      fly.style.left = x1 - 36 + 'px';
      fly.style.top = y1 - 45 + 'px';
      var im = document.createElement('img');
      im.src = shot.currentSrc || shot.src;
      fly.appendChild(im);
      document.body.appendChild(fly);
      requestAnimationFrame(function () {
        fly.style.transform = 'translate(' + dx.toFixed(0) + 'px, ' + dy.toFixed(0) + 'px) scale(0.12) rotate(14deg)';
        fly.style.opacity = '0';
      });
      setTimeout(function () { fly.remove(); }, 780);
    }
  }

  function initWebShoot() {
    var atc = document.querySelector('.pdp__atc');
    if (atc) {
      atc.addEventListener('click', function () { flyToCart(atc); });

      // sentido aranha quando o mouse chega perto do botão
      var buy = atc.closest('.pdp__buy') || atc.parentElement;
      if (buy && !reduced) {
        var rings = [];
        for (var i = 1; i <= 3; i++) {
          var r = document.createElement('span');
          r.className = 'sp-sense sp-sense--' + i;
          buy.appendChild(r);
          rings.push(r);
        }
        var armed = true;
        buy.addEventListener('pointerenter', function () {
          if (!armed) return;
          armed = false;
          rings.forEach(function (r) { r.classList.remove('is-on'); void r.offsetWidth; r.classList.add('is-on'); });
          setTimeout(function () { armed = true; }, 2600);
        });
      }
    }
  }

  /* ---------- 8. A aranha desce junto com a rolagem ---------- */
  function initDrop() {
    var sp = document.querySelector('.sp-spider');
    if (!sp || reduced) return;
    var ticking = false;
    function update() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(window.scrollY / max, 1) : 0;
      sp.style.setProperty('--sp-drop', (130 + p * (window.innerHeight * 0.45)).toFixed(0) + 'px');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  /* ---------- 9. Sem personalização: trava os campos de nome/número do combo ---------- */
  function initNoPerso() {
    var skin = document.querySelector("[data-sp-skin]");
    var lbl = skin && (skin.getAttribute("data-combo-label") || "").trim();
    var title = document.querySelector(".cmb__title");
    if (title && lbl) title.textContent = lbl;
    var free = document.querySelector(".cmb__free");
    if (free) free.remove();
    document.querySelectorAll("[data-cname], [data-cnum]").forEach(function (i) {
      i.value = "";
      i.disabled = true;
      var f = i.closest(".pdp__perso-field");
      if (f) f.style.display = "none";
    });
  }

  function boot() {
    initChrome();
    initSwitch();
    initReveal();
    initSizes();
    initUpsell();
    initSuitSwap();
    initWebShoot();
    initDrop();
    initNoPerso();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
